import React, { useState, useEffect, useCallback } from "react";
import RenderTableReports from "./renderTableReports";
import ReportsPagination from "./pagenation";
import SearchReports from "./searchReports";
import { CircularProgress, Box } from "@mui/material";
import { useNotification } from "../../context/NotificationContext";

export default function Reports() {
  const { showNotification } = useNotification();
  const [allReports, setAllReports] = useState([]);
  // eslint-disable-next-line
  const [filteredReports, setFilteredReports] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [aggregator, setAggregator] = useState("");
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const ITEMS_PER_PAGE = 10;

  const fetchReports = useCallback(async () => {
    try {
      setLoading(true);

      const params = new URLSearchParams({
        page: currentPage,
        limit: ITEMS_PER_PAGE,
        search: searchTerm,
        aggregator,
        fromDate,
        toDate,
      });

      const res = await fetch(
        `${process.env.REACT_APP_BACKENDORDERURL}/reports/orders?${params}`,
        {headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },}
      );

      const json = await res.json();

      if (!res.ok || !json.success) {
        throw new Error(json.message || "Failed to fetch reports");
      }

      setAllReports(json.data);
      setTotalPages(json.pagination.totalPages);
      setTotalItems(json.pagination.totalItems);
    } catch (error) {
      showNotification(error.message || "Error fetching reports", "error");
    } finally {
      setLoading(false);
    }
  }, [currentPage, searchTerm, aggregator, fromDate, toDate, showNotification]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, aggregator, fromDate, toDate]);
 
  // Get unique aggregators for dropdown
  const aggregators = Array.from(
    new Set(allReports.map((r) => r.aggregator).filter(Boolean))
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <section className="content-body">
      <div className="d-block justify-content-between reporthead">
        <h3>Reports</h3>
        <SearchReports
          onSearch={setSearchTerm}
          onFromDate={setFromDate}
          onToDate={setToDate}
          fromDate={fromDate}
          toDate={toDate}
          reports={allReports}
          aggregators={aggregators}
          onAggregatorChange={setAggregator}
          aggregator={aggregator}
        />
      </div>

      {/* 🌀 Show loader while fetching */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
          }}
        >
          <CircularProgress color="primary" size={60} />
        </Box>
      ) : (
        <>
          <RenderTableReports reports={allReports} />
          <ReportsPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalItems={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
          />
        </>
      )}
    </section>
  );
}
